import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import messages from '../employeeMessages';

const UpdateProductivityPercentageModal = ({ show, intl, onSave, onClose }) => {
  const [percentage, setPercentage] = useState('');
  const [touched, setTouched] = useState(false);

  const isValid = () => {
    const value = parseFloat(percentage);
    return !Number.isNaN(value) && value >= 0 && value <= 100;
  };

  const handleSave = () => {
    setTouched(true);
    if (!isValid()) return;
    return onSave(parseFloat(percentage));
  };

  const handleClose = () => {
    setPercentage('');
    setTouched(false);
    onClose();
  };

  if (!show) return null;

  const formGroupClassName = classNames('form-group', {
    'has-error': touched && !isValid(),
  });

  return (
    <OkCancelModal
      title={intl.formatMessage(messages.UpdateProductivityPercentage)}
      show={show}
      onClose={handleClose}
      disabled={!isValid()}
      onSave={handleSave}
    >
      <div className="form-horizontal">
        <div className={formGroupClassName}>
          <label className="control-label col-sm-4">
            {intl.formatMessage(messages.ProductivityPercentage)}
          </label>
          <div className="col-sm-5">
            <div className="input-group">
              <input
                type="number"
                step="1"
                min="0"
                max="100"
                value={percentage}
                onChange={e => {
                  setTouched(true);
                  setPercentage(e.target.value);
                }}
                className="form-control"
              />
              <span className="input-group-addon">%</span>
            </div>
          </div>
        </div>
      </div>
    </OkCancelModal>
  );
};

UpdateProductivityPercentageModal.propTypes = {
  show: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UpdateProductivityPercentageModal;
